import "../App.css";
import ChartMap from "../components/ChartMap";
import NumberOfMentions from "../components/NumberOfMentions";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import {
  ConfigProvider,
  DatePicker,
  Radio,
  RadioChangeEvent,
  Select,
  Skeleton,
} from "antd";
import { useEffect, useState } from "react";
import locale from "antd/es/date-picker/locale/ru_RU";
import { LoadingOutlined } from "@ant-design/icons";
import { referencesService } from "../api";
import RegionCard from "../components/RegionCard";
import Input, { SearchProps } from "antd/es/input";
import { regions } from "../scripts/regions";
import { RangePickerProps } from "antd/es/date-picker";
import LazyLoad from 'react-lazyload';

function Main() {
  const [value, setValue] = useState("today");
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [regionsArr, setRegionsArr] = useState<any>([]);
  const nowDate = new Date().toJSON().split("T")[0];
  const [dateString, setDateString] = useState([
    nowDate + " 00:00:00",
    nowDate + " 23:59:59",
  ]);
  const { RangePicker } = DatePicker;
  const { Search } = Input;
  const [loadingPost, setLoadingPost] = useState(true);
  const [loadingMap, setLoadingMap] = useState(true);

  const [regionData, setRegionData] = useState<any>([]);

  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];

  const disabledDate: RangePickerProps["disabledDate"] = (current: any) => {
    return current && current > dayjs().endOf("day");
  };

  useEffect(() => {
    setLoadingMap(true)
    regions?.map((item: any, id: any) => {
      let params = {
        thread_id: item.id,
      date_from: dateString[0],
      date_to: dateString[1],
      };

      referencesService
        .loadRegionMap(params)
        .then((list: any) => {
          Object.assign(regions[id], list);
        })
        .catch((err) => console.log(err));
    });
    setRegionsArr(regions);
    //setTimeout(() => setLoadingMap(false), 1000);
    setLoadingMap(false)
  }, [dateString]);

  useEffect(() => {
    value == "postDesc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => b.errors_count - a.errors_count)
      );
    value == "postAsc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => a.errors_count - b.errors_count)
      );
    value == "errorDesc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => b.failures_count - a.failures_count)
      );
    value == "errorAsc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => a.failures_count - b.failures_count)
      );
  }, [sort]);

  useEffect(() => {
    setLoadingPost(true);
    let params = {
      thread_id: 23645,
      date_from: dateString[0],
      date_to: dateString[1],
    };

    referencesService
      .loadRegions(params)
      .then((list: any) => {
        let posts = list?.failures;
        posts.data = list?.failures.data.map((item: number) =>
          (item / 89).toFixed(2)
        );

        setRegionData([posts, list?.errors]);
        setLoadingPost(false);
      })
      .catch((err) => console.log(err));
  }, [dateString]);

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);
    value == "today" &&
      setDateString([nowDate + " 00:00:00", nowDate + " 23:59:59"]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };
  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString([dateString[0] + " 00:00:00", dateString[1] + " 23:59:59"]);
  };

  const onSearch = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearch(e.target.value);
  };

  const handleChangeSort = (value: string) => {
    setSort(value);
    value == "postDesc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => b.errors_count - a.errors_count)
      );
    value == "postAsc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => a.errors_count - b.errors_count)
      );
    value == "errorDesc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => b.failures_count - a.failures_count)
      );
    value == "errorAsc" &&
      setRegionsArr(
        regions.sort((a: any, b: any) => a.failures_count - b.failures_count)
      );

    value == "problem" &&
      setRegionsArr(regions.filter((item: any) => item.errors_count >= 200));

    value == "noproblem" &&
      setRegionsArr(regions.filter((item: any) => item.errors_count < 200));
  };

  return (
    <div className="App">
      <div className="flex-space">
        <div></div>
        <div className="flex mobile_revert ">
          <ConfigProvider
            theme={{
              components: {
                Radio: {
                  buttonSolidCheckedColor: "#d14f64",
                  buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
                  colorPrimary: "rgba(0, 0, 0, 0.1)",
                  buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <Radio.Group
              options={options}
              onChange={onChange}
              value={value}
              optionType="button"
              buttonStyle="solid"
            />
          </ConfigProvider>
          {value == "period" && (
            <RangePicker
              format={"DD-MM-YYYY"}
              onChange={onPeriodChange}
              style={{ width: "278px" }}
              className="choose-period"
              allowClear={false}
              locale={locale}
              disabledDate={disabledDate}
            />
          )}
        </div>
      </div>
      <div className="grid2">
        {loadingMap ? (
          <div className="feed-posts-loader" style={{ height: "300px" }}>
            <LoadingOutlined />
          </div>
        ) : (
          regionsArr && <ChartMap regions={regionsArr} />
        )}
        {loadingPost ? (
          <div className="feed-posts-loader" style={{ height: "300px" }}>
            <LoadingOutlined />
          </div>
        ) : (
          <>
            {regionData.length == 2 && (
              <NumberOfMentions data={regionData} refer="double" />
            )}
          </>
        )}
      </div>
      <div className="flex">
        <Search
          placeholder="Название региона"
          onChange={onSearch}
          style={{ width: 300 }}
        />

        <Select
          style={{ width: 300 }}
          onChange={handleChangeSort}
          disabled={loadingPost}
          options={[
            { value: "problem", label: "Проблемы с доступом" },
            { value: "noproblem", label: "Умеренный фон" },
            { value: "postAsc", label: "Меньше жалоб" },
            { value: "postDesc", label: "Больше жалоб" },
            { value: "errorDesc", label: "Больше ошибок" },
            { value: "errorAsc", label: "Меньше ошибок" },
          ]}
          placeholder="Сортировать по"
        />
      </div>
      <div className="grid2">
        {regionsArr &&
          regionsArr?.map(
            (item: any, id: any) =>
              item?.id != "23645" &&
              item?.id != "23648" &&
              item?.threadname.toUpperCase().includes(search.toUpperCase()) && (
                <LazyLoad height={200} offset={100} once key={item.id}>
                  <RegionCard item={item}  date={dateString}/>
                </LazyLoad>
              )
          )}
      </div>
    </div>
  );
}

export default Main;
